module.exports = __webpack_public_path__ + "static/media/logo.a017edb2.png";